import { toString30pk9tzaqopn as toString } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  toString1pkumu07cwy4m as toString_0,
  hashCodeq5arwsb9dgti as hashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var AuthHookDataClass;
function AuthHookData() {
  if (AuthHookDataClass === VOID) {
    class $ {
      constructor(user, authenticated, loading, error, loginWithRedirect, getIdTokenClaims, logout, getAccessTokenSilently) {
        this.h3r_1 = user;
        this.i3r_1 = authenticated;
        this.j3r_1 = loading;
        this.k3r_1 = error;
        this.l3r_1 = loginWithRedirect;
        this.m3r_1 = getIdTokenClaims;
        this.n3r_1 = logout;
        this.o3r_1 = getAccessTokenSilently;
      }
      ef() {
        return this.i3r_1;
      }
      p3r() {
        return this.j3r_1;
      }
      toString() {
        return 'AuthHookData(user=' + toString(this.h3r_1) + ', authenticated=' + this.i3r_1 + ', loading=' + this.j3r_1 + ', error=' + toString(this.k3r_1) + ', loginWithRedirect=' + toString_0(this.l3r_1) + ', getIdTokenClaims=' + toString_0(this.m3r_1) + ', logout=' + toString_0(this.n3r_1) + ', getAccessTokenSilently=' + toString_0(this.o3r_1) + ')';
      }
      hashCode() {
        var result = this.h3r_1 == null ? 0 : hashCode(this.h3r_1);
        result = imul(result, 31) + getBooleanHashCode(this.i3r_1) | 0;
        result = imul(result, 31) + getBooleanHashCode(this.j3r_1) | 0;
        result = imul(result, 31) + (this.k3r_1 == null ? 0 : hashCode(this.k3r_1)) | 0;
        result = imul(result, 31) + hashCode(this.l3r_1) | 0;
        result = imul(result, 31) + hashCode(this.m3r_1) | 0;
        result = imul(result, 31) + hashCode(this.n3r_1) | 0;
        result = imul(result, 31) + hashCode(this.o3r_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof AuthHookData()))
          return false;
        if (!equals(this.h3r_1, other.h3r_1))
          return false;
        if (!(this.i3r_1 === other.i3r_1))
          return false;
        if (!(this.j3r_1 === other.j3r_1))
          return false;
        if (!equals(this.k3r_1, other.k3r_1))
          return false;
        if (!equals(this.l3r_1, other.l3r_1))
          return false;
        if (!equals(this.m3r_1, other.m3r_1))
          return false;
        if (!equals(this.n3r_1, other.n3r_1))
          return false;
        if (!equals(this.o3r_1, other.o3r_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'AuthHookData');
    AuthHookDataClass = $;
  }
  return AuthHookDataClass;
}
//region block: exports
export {
  AuthHookData as AuthHookData2x0lxghdz8ao,
};
//endregion

//# sourceMappingURL=AuthHookData.mjs.map
